import getConfig from 'next/config';

import path from 'path';

import { FlagsmithOfflineClient } from '@ha/core/Flagsmith/FlagsmithOfflineClient';

import { logger } from '@kamernet/core/Logger';

import { isDevelopment } from '../Environment';

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

let flagsmithServerClient: FlagsmithOfflineClient;

export function initializeFlagsmithServerClient(): void {
  if (flagsmithServerClient) {
    logger.warn('initializeFlagsmithServerClient is called more than once');
    return;
  }

  flagsmithServerClient = new FlagsmithOfflineClient({
    logger,
    options: {
      apiUrl: serverRuntimeConfig.FLAGSMITH_API_URL,
      environmentKey: serverRuntimeConfig.FLAGSMITH_ENVIRONMENT_KEY,
      enableLocalEvaluation:
        serverRuntimeConfig.FLAGSMITH_ENABLE_LOCAL_EVALUATION,
      requestTimeoutSeconds:
        serverRuntimeConfig.FLAGSMITH_REQUEST_TIMEOUT_SECONDS,
      customHeaders: {
        'X-Application-Name': 'app-nextjs',
        'X-Environment': publicRuntimeConfig.DEPLOYMENT_ID,
        'User-Agent': `app-nextjs,${publicRuntimeConfig.DEPLOYMENT_ID}`,
      },
    },
    offlineOptions: {
      offlineEnvironmentPath: path.resolve(
        __dirname,
        isDevelopment()
          ? '../../../offline_flagsmith.json'
          : '/config/flagsmith/environment.json',
      ),
    },
  });

  logger.info('A new FlagsmithClient instance is created');
}

export function getFlagsmithServerClient(): FlagsmithOfflineClient {
  return flagsmithServerClient;
}
